import type { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react'
import { createContext, useContext, useState } from 'react'
import type { Catalog } from '@model/pricelist/Catalog'
import { useRouter } from 'next/router'

const Context = createContext<{
  currentCatalog: Catalog | null
  setCurrentCatalog: Dispatch<SetStateAction<Catalog | null>>
  handleCatalogSelect: () => Promise<void>
}>({
  currentCatalog: null,
  setCurrentCatalog: () => ({}),
  handleCatalogSelect: () => Promise.resolve(),
})

const ModalStateProvider: FC<PropsWithChildren> = ({ children }) => {
  const {
    asPath,
    query: { catalogId },
    replace,
  } = useRouter()

  const [currentCatalog, setCurrentCatalog] = useState<Catalog | null>(null)

  const exposed = {
    currentCatalog,
    setCurrentCatalog,
    handleCatalogSelect: async () => {
      if (!currentCatalog) return

      const newUrl = asPath.replace(catalogId as string, currentCatalog)
      await replace(newUrl)
      setCurrentCatalog(null)
    },
  }

  return <Context.Provider value={exposed}>{children}</Context.Provider>
}

export const useModalState = () => useContext(Context)
export default ModalStateProvider
